import { Component, OnInit } from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {AppConfigService} from "../../services/config/app-config.service";
import {TokenStorageService} from "../../services/storage/token-storage.service";
import {environment} from "../../../environments/environment";

@Component({
    selector: 'app-base64-encoder',
    templateUrl: './base64-encoder.component.html',
    styleUrl: './base64-encoder.component.css',
    standalone: false
})
export class Base64EncoderComponent implements OnInit {
  env: string | null;
  base64EncoderUrl: SafeResourceUrl | null = null;

  constructor(appConfig: AppConfigService, private tokenStorageService: TokenStorageService, private sanitizer: DomSanitizer) {
    this.env = tokenStorageService.getUserEnv();
  }

  ngOnInit(): void {
    this.base64EncoderUrl = this.sanitizer.bypassSecurityTrustResourceUrl(environment.base64EncoderUrl);
  }
}
